import React from "react";
import "../../assets/scss/components/generic/radioButton.scss";
import { IListObj } from "../types/genericTypes";

export interface RadioButtonProps {
  list: IListObj; //list of all options in radio btn
  name: string;
  selected?: number | string; // selected value
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
  moduleName?: "orderBook" | "orderPlacement" | "fundTransfer" | "nominationOptional"; // takes orderBook as default
  disabled?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const moduleName = props.moduleName ? props.moduleName : "orderBook";
  return (
    <label className={"radio_btn " + moduleName}>
      <input
        type="radio"
        value={props.list.value}
        name={props.name}
        key={props.list.value}
        checked={props.selected === props.list.value}
        onChange={props.onChange}
        disabled={props.disabled ? props.disabled : false}
      />
      <span className="checkmark"></span>
      <span className={"disp_val " + moduleName}> {props.list.display}</span>
    </label>
  );
};

export default RadioButton;
